import React, { PropsWithChildren, SetStateAction, useContext, useEffect, useRef, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { Pressable, PressableProps, ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { CustomDivider } from "@/components/CustomDivider";
import { Link } from 'expo-router';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { Image } from 'expo-image';

interface PressableWithTitleProps extends PressableProps {
  title: string,
};

export function PressableWithTitle({
  title,
  children,
  ...props
}: PropsWithChildren<PressableWithTitleProps>) : React.ReactNode {

  const ref = useRef<React.ComponentRef<typeof Pressable>>(null);

  useEffect(() => {
    if (ref.current) {
      // TODO: https://github.com/necolas/react-native-web/issues/2828
      if (typeof (ref.current as any).setAttribute === 'function') {
        (ref.current as any).setAttribute("title", title);
      }
    }
  }, [ref]);

  return (
    <Pressable {...props} ref={ref}>
      { children }
    </Pressable>
  );
};
